import React, {useState} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {Button} from "@mui/material";
import ShuffleIcon from "@mui/icons-material/Shuffle";

import {FEATURE_PICKER_TYPE} from "../../../../../constants";
import {setFeaturePicker} from "../../../../../../../actions/sqftMenuFunctions";
import sqftShape from "../../../../canvas/core/shapes/sqftShape";
import ConfirmButtons from "../ConfirmButtons";
import {changeShapeLayout} from "../../../../../helpers/cabinetsHelper";
import {setResourceControllerCounter} from "../../../../../../../actions/sqftResourceFunctions";
import ShapeResizeAutoShift from "../../../../canvas/core/shapes/shapeParts/ShapeResizeAutoShift";
import {reloadCountertopsIn3DMode, reloadShapesIn3DMode} from "../../../../../helpers/3dHelper/modelsHelper";
import {is3DMode} from "../../../NavigationHelper";
import workspaceControllers from "../../../../canvas/store/workspaceControllers";

const CustomSizeSwapButton = (props) => {
  const {featurePicker, setFeaturePicker, selectedFeatureInPicker, setResourceControllerCounter,
    resourceControllerCounter, setCustomSizeListKey} = props;
  const {shape} = props;
  const [isProcessing, setProcessing] = useState(false);

  const swapCabinetClick = () => {
    setFeaturePicker(
      {
        isOpen: true,
        modelId: "",
        featureId: shape.featureId,
        sharedFeatureName: shape.getFeature()?.dbFeature?.sharedFeatureName,
        partIds: [shape.partId],
        shapeId: shape.id,
        type: FEATURE_PICKER_TYPE.shape
      }
    )
  }

  const confirmCallback = async () => {
    if (isProcessing) {
      return;
    }
    setProcessing(true);

    const oldWidth = shape.getWidth();
    const oldDepth = shape.getDepth();

    shape.setFeatureId(selectedFeatureInPicker);
    const newFeature = shape.getFeature();
    changeShapeLayout(newFeature, shape);

    const newWidth = shape.getWidth();
    const newDepth = shape.getDepth();
    const widthDiff = newWidth - oldWidth;
    const depthDiff = newDepth - oldDepth;

    const currentPosition = shape.getPosition();
    const absolutePosition = shape.shapeAbsolute?.getAbsolutePosition();
    shape.setPosition({x: currentPosition.x - widthDiff / 2, y: currentPosition.y - depthDiff / 2});
    if (absolutePosition) {
      shape.shapeAbsolute.setAbsolutePos({x: currentPosition.x - widthDiff / 2, y: currentPosition.y - depthDiff / 2});
    }
    shape.setOriginalPointsCoords(shape.getPointsCoords());
    setResourceControllerCounter(resourceControllerCounter + 1);
    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });

    const autoShift = new ShapeResizeAutoShift(shape);
    autoShift.handleWidthResizeAutoShift(oldWidth, newWidth);
    autoShift.handleDepthResizeAutoShift(oldDepth, newDepth);

    if (is3DMode()) {
      try {
        const snappedShapes = workspaceControllers.snappedShapeGroups.getSnappedShapesForTheShape(shape);
        await reloadShapesIn3DMode([...snappedShapes, shape]);
        await reloadCountertopsIn3DMode([...snappedShapes, shape]);
      } finally {
        setProcessing(false);
      }
    } else {
      setProcessing(false);
    }
    setCustomSizeListKey(prev => prev + 1);
  };

  const cancelCallback = () => {
    if (isProcessing) {
      return;
    }

    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
  }

  return (
    featurePicker.isOpen
    && featurePicker.type === FEATURE_PICKER_TYPE.shape
      ? <div
        style={{
          pointerEvents: isProcessing ? 'none' : 'auto',
          opacity:        isProcessing ? 0.6      : 1,
          transition:     'opacity 0.2s'
        }}
        >
          <ConfirmButtons confirmCallback={confirmCallback} cancelCallback={cancelCallback}/>
        </div>
      : <Button
        className={"sr__button "}
        variant="outlined"
        color="primary"
        startIcon={<ShuffleIcon style={{ transform: 'rotate(180deg)' }}/>}
        onClick={swapCabinetClick}
      >
        <FormattedMessage id={"sqft.cabinets.attributes.swapCabinet"}/>
      </Button>
  );
};

CustomSizeSwapButton.prototype = {
  shape: PropTypes.instanceOf(sqftShape),
  setCustomSizeListKey: PropTypes.func
}

const mapStateToProps = (store) => {
  const {featurePicker, selectedFeatureInPicker} = store.sqftMenuState;
  const {resourceControllerCounter} = store.sqftResourceState;

  return {
    featurePicker: featurePicker,
    selectedFeatureInPicker: selectedFeatureInPicker,
    resourceControllerCounter: resourceControllerCounter,
  }
};

const mapDispatchToProps = {
  setFeaturePicker,
  setResourceControllerCounter,
};


export default connect(mapStateToProps, mapDispatchToProps)(CustomSizeSwapButton);
